import React, { useContext, useMemo, useState } from "react";
import '../../css/templates.css';
import SelectBox from "../elements/selectBox";
import DataLine from "../elements/dataLine";
import { useSelector } from 'react-redux';
import { fetchWithDefaults } from "../../config/fetchDefault";
import { formatTimestamp } from "../../utilities/dashFunction";
import { AgentContext } from "../../context/AgentContext";



function FollowUp({ data,formatDate }) {
    const statuses=useSelector((state) => state.status.status);
    const workflows=useSelector((state) => state.workflows.workflows);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const [editingTemplate, setEditTemplate] = useState(false);
    const [addScript, setAddScript] = useState(false);
    const [followUps, setFollowUps] = useState(data[0]);
    const agentInfo = useSelector((state) => state.agent.userData);
    const textingNumbers = useSelector((state) => state.agent.textingNumbers);

    let noResult=false;
    if(followUps.status==false){
        noResult=true;
    }

    const statusMap = useMemo(()=>{
        if (statuses){
            return statuses.reduce((obj,item)=>{
                obj[item.id] = item.name;
                return obj;
            },{})
        }
        return {};
    },[statuses])

    const updateLeadStatus = async (status, lead, index) => {

        const foundWorkflow = statuses.find(workflow => workflow.id === status);

        try {
                       const requestOptions = {
                           method: 'PATCH',
                           body: JSON.stringify({
                               agent: agentInfo.agentId,
                               leadId: lead,
                               statusId: status,
                               status: foundWorkflow,
                               teamId: agentInfo.teamId,
                               textingNumbers: textingNumbers
                           }),
                       };
                       //setSuccessTrigger(true);
                       const response = await fetchWithDefaults('/lead/status', requestOptions);
                       if (!response.ok) {
                           throw new Error('Network response was not ok');
                       }
                   } catch (error) {
                       console.error('Error fetching data:', error);
                   }

    };

    const outOfDate=(last)=>{
        let current=currentTimestamp - last;
        let period=Math.round(current/86400);
        return period;
    }

    const setUpStatusUpdate=async (status,options)=>{
        updateLeadStatus(status.id, options.lead, options.index);
    }

    const {isB2B} = useContext(AgentContext)
    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`} style={{textAlign:'center'}}>
            <span className="outerWrapperTitle">
                <span className="outerWrapperIcon">

                </span>
                Follow-Ups
            </span>


            <div className={`frontPageQuilityParentBlockWrapper ${addScript ? 'closeMainBlock' : editingTemplate ? 'closeMainBlock' : ''}`} style={{width: '70%'}}>
                <div className="quilityParentBlockHeader">
                    <div className="quilityParentBlockTitle">Leads That Need a Follow Up</div>
                </div>
                <div className="quilityParentBlockContent followups">
                    {followUps.length < 1 ? (
                        <span className="noResults">You are all caught up!</span>
                    ) : (
                        noResult ? (
                            null
                        ) : (
                            followUps.map((lead, index) => (
                                <div className="quilityNestedBlockWrapper " key={`followUp${index}`} style={{marginTop: '25px'}}>
                                    <div class="quilityNestedBlockHeader">
                                        <div class="quilityParentBlockTitle">{lead.borrower_first} {lead.borrower_last}</div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="innerContentWrapper">
                                            <DataLine title="Appointment Date"  value={formatTimestamp(lead.app_date)}/>
                                            <DataLine title="Last Status Change" value={formatTimestamp(lead.last_change)}/>
                                            <DataLine title="Current Status" value={lead.name}/>
                                            <DataLine title="Day's Out of Date" value={outOfDate(lead.app_date)}/>
                                            <SelectBox handleChange={setUpStatusUpdate} title="Lead Status" options={statuses} value={statusMap[lead.status_id]} passBack={{lead:lead.app_lead,index:index}}/>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )
                    )}
                </div>
                <div className="blockFooter">
                    <div
                        className="buttonWrapper"
                        style={{ marginTop: " 5px", marginLeft: "10px" }}
                    >
                        <div className="dataButtonBlock">Follow Ups: {followUps.status != false ? followUps.length : 0}</div>
                        <div className="actionButtonBlock" style={{width: '150px'}}>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default FollowUp;